/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <section className={styles.section}>
      <h2 className={styles.h2}>1 - HTML</h2>
      <p className={styles.description}>
        <b>HyperText Markup Language (язык разметки гипертекста)</b> — стандартизированный язык разметки документов во
        Всемирной паутине. Это набор правил, которые используются для структурирования (разметки) текстовой информации,
        добавления внешних изображений, создания таблиц, списков и т.д.
      </p>
      <p className={styles.description}>
        <b>HTML-документ</b> — это обычный текстовый документ, который имеет расширение{' '}
        <code className={styles.code}>.html</code>. Документ, размеченный с помощью HTML, интерпретируется браузером, в
        результате чего, пользователи видят не исходный код с элементами разметки, а итоговый результат обработки
        HTML-документа.
      </p>
      <p className={styles.notificationWarn}>
        Вы читаете HTML-документ прямо сейчас, так как конспект это веб-страница размеченная используя HTML-синтаксис.
      </p>
    </section>

    <h2 className={styles.h3}>1.1 - Введение</h2>
    <p className={styles.description}>
      Веб-сайты это основа на которой держится интернет. Большинство веб-сайтов создается используя три технологии:
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <code className={styles.code}>HTML</code> - отвечает за наполнение веб-страницы контентом, структурирование
        информации и выделение логических блоков веб-страницы.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>CSS</code> - используется для оформления и позиционирования, представления
        информации на странице.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>JavaScript</code> - используется для добавления функционала, интерактивного
        взаимодействия с пользователем.
      </li>
    </ul>
    <p className={styles.description}>
      Появление <code className={styles.code}>HTML</code> было обусловлено необходимостью создания простого средства
      разметки документов для облегчения навигации по информации, которым бы могли воспользоваться люди не имеющие
      специальных технических знаний.
    </p>
  </section>
))
